export const _privileges = {
    additional: ['not_entity_related'],
    create: ['user'],
    read: ['user'],
    update: ['user'],
    delete: ['user'],
};
//# sourceMappingURL=_privileges.js.map